import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db, auth } from '../firebaseConfig';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Link } from 'react-router-dom';
import '../styles/FilteredMembers.css';

const FilteredMembers = () => {
  const [filterOption, setFilterOption] = useState({
    sex: [],
    sexualOrientation: [],
    spectrum: [],
    aim: [],
    partner_sex: [],
    hope: [],
    marriage_aim: [],
    skinship: [],
    love_exist: 'all',
    holiday: 'all',
    contact: 'all',
    cohabitant: 'all',
    tobacco: 'all',
    alcohol: 'all',
    sex_hope: 'all',
    children_want: 'all',
    children_have: 'all',
    marital_status: 'all',
    educationc: 'all',
    income: 'all',
    works: 'all',
    figure: 'all',
    minAge: 'all',
    maxAge: 'all',
    minHeight: 'all',
    maxHeight: 'all',
    location: 'all',
    cohabiter_aim: 'all',
    friendship_marriage: 'all',
  });

  const [isBasicVisible, setIsBasicVisible] = useState(true);
  const [isDetailsVisible, setIsDetailsVisible] = useState(false);
  const [isRelationshipVisible, setIsRelationshipVisible] = useState(false); // 恋愛・結婚観セクションの状態

  const [user] = useAuthState(auth);
  const navigate = useNavigate();

  useEffect(() => {
    const loadFilterOptions = async () => {
      if (user) {
        const filterDocRef = doc(db, 'filterOptions', user.uid);
        const filterDoc = await getDoc(filterDocRef);
        if (filterDoc.exists()) {
          const data = filterDoc.data();
          setFilterOption((prevState) => ({
            ...prevState,
            ...data,
            sex: Array.isArray(data.sex) ? data.sex : [],
            aim: Array.isArray(data.aim) ? data.aim : [],
            sexualOrientation: Array.isArray(data.sexualOrientation)
              ? data.sexualOrientation
              : [],
            spectrum: Array.isArray(data.spectrum) ? data.spectrum : [],
          }));
        }
      }
    };
    loadFilterOptions();
  }, [user]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterOption((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const handleApplyFilter = async () => {
    if (user) {
      const filterDocRef = doc(db, 'filterOptions', user.uid);
      await setDoc(filterDocRef, filterOption);
      navigate('/member_search');
    }
  };

  const handleFilterChangeMultiple = (e) => {
    const { name, value, checked } = e.target;
    if (!name || !value) return;

    setFilterOption((prevState) => {
      const currentValues = Array.isArray(prevState[name]) ? prevState[name] : [];
      if (value === 'こだわらない') {
        return checked ? { ...prevState, [name]: ['all'] } : { ...prevState, [name]: [] };
      }

      const updatedValues = checked
        ? [...currentValues.filter((v) => v !== 'all'), value]
        : currentValues.filter((v) => v !== value);

      return { ...prevState, [name]: updatedValues };
    });
  };

  const renderCheckboxGroup = (name, options) => (
    <div className="radio-button-group">
      {options.map((option) => {
        const isChecked =
          filterOption[name]?.includes(option) ||
          (option === 'こだわらない' && filterOption[name]?.includes('all'));

        return (
          <label key={option} className={`radio-button ${isChecked ? 'checked' : ''}`}>
            <input
              type="checkbox"
              name={name}
              value={option}
              checked={isChecked}
              onChange={handleFilterChangeMultiple}
            />
            <span className="button-text">{option}</span>
          </label>
        );
      })}
    </div>
  );

  return (
    <div className="filtered-members-container">
      <div className="header">
        <Link to="/" className="back-link-cont">←</Link>
        <p className="settings-title-cont">絞り込み設定</p>
      </div>

      <p
        className="toggle-section"
        onClick={() => setIsBasicVisible((prev) => !prev)}
      >
        基本項目
        <span className="toggle-icon">{isBasicVisible ? '∨' : '＞'}</span>
      </p>
      {isBasicVisible && (
        <div className="basic-section">
          <p>年齢：</p>
          <div className="filtered-members-form-group-x">
            <div className="filtered-members-age-group">
              <select
                name="minAge"
                value={filterOption.minAge}
                onChange={handleFilterChange}
                className="filtered-members-select-x"
              >
                {Array.from({ length: 53 }, (_, i) => i + 18).map((age) => (
                  <option key={age} value={age}>
                    {age}
                  </option>
                ))}
              </select>
              <span>〜</span>
              <select
                name="maxAge"
                value={filterOption.maxAge}
                onChange={handleFilterChange}
                className="filtered-members-select-x"
              >
                {Array.from({ length: 53 }, (_, i) => i + 18).map((age) => (
                  <option key={age} value={age}>
                    {age}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="filtered-members-form-group">
        <label>居住地:</label>
        <select name="location" value={filterOption.location} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
          <option value="北海道">北海道</option>
          <option value="青森">青森</option>
          <option value="岩手">岩手</option>
          <option value="宮城">宮城</option>
          <option value="秋田">秋田</option>
          <option value="山形">山形</option>
          <option value="福島">福島</option>
          <option value="茨城">茨城</option>
          <option value="栃木">栃木</option>
          <option value="群馬">群馬</option>
          <option value="埼玉">埼玉</option>
          <option value="千葉">千葉</option>
          <option value="東京">東京</option>
          <option value="神奈川">神奈川</option>
          <option value="新潟">新潟</option>
          <option value="富山">富山</option>
          <option value="石川">石川</option>
          <option value="福井">福井</option>
          <option value="山梨">山梨</option>
          <option value="長野">長野</option>
          <option value="岐阜">岐阜</option>
          <option value="静岡">静岡</option>
          <option value="愛知">愛知</option>
          <option value="三重">三重</option>
          <option value="滋賀">滋賀</option>
          <option value="京都">京都</option>
          <option value="大阪">大阪</option>
          <option value="兵庫">兵庫</option>
          <option value="奈良">奈良</option>
          <option value="和歌山">和歌山</option>
          <option value="鳥取">鳥取</option>
          <option value="島根">島根</option>
          <option value="岡山">岡山</option>
          <option value="広島">広島</option>
          <option value="山口">山口</option>
          <option value="徳島">徳島</option>
          <option value="香川">香川</option>
          <option value="愛媛">愛媛</option>
          <option value="高知">高知</option>
          <option value="福岡">福岡</option>
          <option value="佐賀">佐賀</option>
          <option value="長崎">長崎</option>
          <option value="熊本">熊本</option>
          <option value="大分">大分</option>
          <option value="宮崎">宮崎</option>
          <option value="鹿児島">鹿児島</option>
          <option value="沖縄">沖縄</option>
        </select>
      </div>

          <p>性別（複数選択可）:</p>
          {renderCheckboxGroup('sex', ['こだわらない', '男性', '女性', 'トランス男性(FtM)', 'トランス女性(MtF)', 'ノンバイナリー','その他'])}

<p>スペクトラム（複数選択可）:</p>
          {renderCheckboxGroup('spectrum', [
            'こだわらない',
            'アセクシャル',
            'グレイセクシャル',
            'デミセクシャル',
            'リスセクシャル',
            'ノンセクシャル',
          ])}

          <p>性的指向（複数選択可）:</p>
          {renderCheckboxGroup('sexualOrientation', [
            'こだわらない',
            'ストレート',
            'ゲイ',
            'レズビアン',
            'バイセクシャル',
            'パンセクシュアル',
            'その他',
          ])}

<p>求める相手（複数選択可）:</p>
      {renderCheckboxGroup('aim', ['こだわらない', '友人', '恋人', '結婚相手', 'パートナー', 'その他'])}


      <p>パートナーに望む性別（複数選択可）:</p>
          {renderCheckboxGroup('partner_sex', ['こだわらない', '男性', '女性', 'トランス男性(FtM)', 'トランス女性(MtF)', 'ノンバイナリー','その他'])}


<p>会う時の希望（複数選択可）:</p>
          {renderCheckboxGroup('hope', [
            'こだわらない',
            '日中',
            'パブリックな場所',
            '日中+パブリックな場所',
            'その他',
          ])}



        </div>
        
      )}

      <p
        className="toggle-section"
        onClick={() => setIsDetailsVisible((prev) => !prev)}
      >
        詳細項目
        <span className="toggle-icon">{isDetailsVisible ? '∨' : '＞'}</span>
      </p>
      {isDetailsVisible && (
        <div className="details-section">
<br></br>
      <p >身長:</p>
      <div className="filtered-members-form-group-x">
  <div className="filtered-members-age-group">
    <select name="minHeight" value={filterOption.minHeight} onChange={handleFilterChange} className="filtered-members-select-x">
      <option value="all">すべて</option>
      {Array.from({ length: 70 }, (_, i) => i + 130).map(height => (
        <option key={height} value={height}>{height}</option>
      ))}
    </select>
    <span>〜</span>
    <select name="maxHeight" value={filterOption.maxHeight} onChange={handleFilterChange} className="filtered-members-select-x">
      <option value="all">すべて</option>
      {Array.from({ length: 70 }, (_, i) => i + 130).map(height => (
        <option key={height} value={height}>{height}</option>
      ))}
    </select>
  </div>
</div>

<div className="filtered-members-form-group">
<label>体型：</label>
        <select name="figure" value={filterOption.figure} onChange={handleFilterChange} className="filtered-members-select">
        <option value="all">すべて</option>
<option value="普通">普通</option>
        <option value="細身">細身</option>
<option value="筋肉質">筋肉質</option>
<option value="がっしり">がっしり</option>
<option value="ぽっちゃり">ぽっちゃり</option>
<option value="ふくよか">ふくよか</option>
<option value="その他">その他</option>
        </select>
      </div>

      <div className="filtered-members-form-group">
        <label>収入:</label>
        <select name="income" value={filterOption.income} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
          <option value="200万円未満">200万円未満</option>
<option value="200〜400万円">200〜400万円</option>
<option value="400〜600万円">600〜800万円</option>
<option value="800〜1000万円">800〜1000万円</option>
<option value="1000万円以上">1000万円以上</option>
        </select>
      </div>


      <div className="filtered-members-form-group">
        <label>職業:</label>
        <select name="works" value={filterOption.works} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
    <option value="all">すべて</option>
    {/* ここにすべての職業を追加 */}
    <option value="学生">学生</option>
    <option value="会社員">会社員</option>
    <option value="公務員">公務員</option>
    <option value="教員">教員</option>
    <option value="医師">医師</option>
    <option value="看護師">看護師</option>
    <option value="弁護士">弁護士</option>
    <option value="エンジニア">エンジニア</option>
    <option value="デザイナー">デザイナー</option>
    <option value="クリエイター">クリエイター</option>
    <option value="営業職">営業職</option>
    <option value="経営者">経営者</option>
    <option value="フリーランス">フリーランス</option>
    <option value="自営業">自営業</option>
    <option value="研究職">研究職</option>
    <option value="介護士">介護士</option>
    <option value="芸術家">芸術家</option>
    <option value="農業">農業</option>
    <option value="漁業">漁業</option>
    <option value="作家">作家</option>
    <option value="販売員">販売員</option>
    <option value="飲食業">飲食業</option>
    <option value="サービス業">サービス業</option>
    <option value="無職">無職</option>
    <option value="主婦/主夫">主婦/主夫</option>
    <option value="アルバイト">アルバイト</option>
    <option value="教師">教師</option>
    <option value="教授">教授</option>
    <option value="大学講師">大学講師</option>
    <option value="消防士">消防士</option>
    <option value="警察官">警察官</option>
    <option value="パイロット">パイロット</option>
    <option value="キャビンアテンダント">キャビンアテンダント</option>
    <option value="運転手">運転手</option>
    <option value="通訳">通訳</option>
    <option value="翻訳家">翻訳家</option>
    <option value="ジャーナリスト">ジャーナリスト</option>
    <option value="報道記者">報道記者</option>
    <option value="イベントプランナー">イベントプランナー</option>
    <option value="音楽家">音楽家</option>
    <option value="俳優">俳優</option>
    <option value="声優">声優</option>
    <option value="ダンサー">ダンサー</option>
    <option value="モデル">モデル</option>
    <option value="美容師">美容師</option>
    <option value="メイクアップアーティスト">メイクアップアーティスト</option>
    <option value="アナウンサー">アナウンサー</option>
    <option value="シェフ">シェフ</option>
    <option value="料理人">料理人</option>
    <option value="スポーツ選手">スポーツ選手</option>
    <option value="トレーナー">トレーナー</option>
    <option value="インストラクター">インストラクター</option>
    <option value="ヨガインストラクター">ヨガインストラクター</option>
    <option value="パーソナルトレーナー">パーソナルトレーナー</option>
    <option value="農家">農家</option>
    <option value="漁師">漁師</option>
    <option value="建設作業員">建設作業員</option>
    <option value="建築士">建築士</option>
    <option value="土木技師">土木技師</option>
    <option value="電気技師">電気技師</option>
    <option value="配管工">配管工</option>
    <option value="大工">大工</option>
    <option value="配達員">配達員</option>
    <option value="宅配ドライバー">宅配ドライバー</option>
    <option value="薬剤師">薬剤師</option>
    <option value="獣医">獣医</option>
    <option value="理学療法士">理学療法士</option>
    <option value="作業療法士">作業療法士</option>
    <option value="心理カウンセラー">心理カウンセラー</option>
    <option value="社会福祉士">社会福祉士</option>
    <option value="臨床検査技師">臨床検査技師</option>
    <option value="放射線技師">放射線技師</option>
    <option value="歯科医">歯科医</option>
    <option value="歯科衛生士">歯科衛生士</option>
    <option value="行政書士">行政書士</option>
    <option value="税理士">税理士</option>
    <option value="不動産業者">不動産業者</option>
    <option value="保険業">保険業</option>
    <option value="金融業">金融業</option>
    <option value="投資家">投資家</option>
    <option value="証券アナリスト">証券アナリスト</option>
    <option value="研究者">研究者</option>
    <option value="マーケター">マーケター</option>
    <option value="データアナリスト">データアナリスト</option>
    <option value="アートディレクター">アートディレクター</option>
    <option value="プロジェクトマネージャー">プロジェクトマネージャー</option>
    <option value="コンサルタント">コンサルタント</option>
    <option value="人事">人事</option>
    <option value="総務">総務</option>
    <option value="広報">広報</option>
    <option value="販売マネージャー">販売マネージャー</option>
    <option value="カスタマーサポート">カスタマーサポート</option>
    <option value="品質管理">品質管理</option>
    <option value="物流管理">物流管理</option>
    <option value="オペレーションマネージャー">オペレーションマネージャー</option>
    <option value="イベントスタッフ">イベントスタッフ</option>
    <option value="企画職">企画職</option>

        </select>
      </div>


      <div className="filtered-members-form-group">
        <label>学歴:</label>
        <select name="educationc" value={filterOption.educationc} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
          <option value="中学卒">中学卒</option>
<option value="高校卒">高校卒</option>
<option value="専門学校卒">専門学校卒</option>
<option value="短大卒">短大卒</option>
<option value="大学卒">大学卒</option>
<option value="大学院卒">大学院卒</option>
<option value="その他">その他</option>
        </select>
      </div>
      <div className="filtered-members-form-group">
        <label>休日:</label>
        <select name="holiday" value={filterOption.holiday} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
          <option value="土日">土日</option>
<option value="平日">平日</option>
<option value="不定期">不定期</option>
<option value="その他">その他</option>
        </select>
      </div>
      <div className="filtered-members-form-group">
        <label>同居人:</label>
        <select name="cohabitant" value={filterOption.cohabitant} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
  <option value="一人暮らし">一人暮らし</option>
  <option value="家族と同居">家族と同居</option>
  <option value="友達と同居">友達と同居</option>
  <option value="ペットと同居">ペットと同居</option>
  <option value="その他">その他</option>
        </select>
      </div>
<div className="filtered-members-form-group">
        <label>連絡頻度:</label>
        <select name="contact" value={filterOption.contact} onChange={handleFilterChange} className="filtered-members-select">
        <option value="all">すべて</option>
        <option value="毎日">毎日</option>
<option value="週数回">週数回</option>
<option value="週1回">週1回</option>
<option value="月数回">月数回</option>
<option value="あまり連絡しない">あまり連絡しない</option>
</select>
      </div>
      <div className="filtered-members-form-group">
        <label>タバコ:</label>
        <select name="tobacco" value={filterOption.tobacco} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
          <option value="吸う">吸う</option>
  <option value="時々吸う">時々吸う</option>
  <option value="吸わない">吸わない</option>
        </select>
      </div>

      <div className="filtered-members-form-group">
        <label>アルコール:</label>
        <select name="alcohol" value={filterOption.alcohol} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">すべて</option>
          <option value="飲む">飲む</option>
  <option value="時々飲む">時々飲む</option>
  <option value="飲まない">飲まない</option>
        </select>
      </div>

          {/* 他の詳細項目をここに追加 */}
        </div>
      )}

      <p
        className="toggle-section"
        onClick={() => setIsRelationshipVisible((prev) => !prev)}
      >
        恋愛・結婚観・友情について
        <span className="toggle-icon">{isRelationshipVisible ? '∨' : '＞'}</span>
      </p>
      {isRelationshipVisible && (
        <div className="relationship-section">
          <p>結婚に対する意思（複数選択可）:</p>
          {renderCheckboxGroup('marriage_aim', [
            'こだわらない',
            'あり',
            'なし',
            'その他',
          ])}
          <p>スキンシップ許容度（複数選択可）:</p>
          {renderCheckboxGroup('skinship', [
            'こだわらない',
            'スキンシップはしたくない',
            'キスまで',
            'ハグまで',
            '手を繋ぐ',
            'その他',
          ])}

          <div className="filtered-members-form-group">
        <label>恋愛感情の有無</label>
        <select name="love_exist" value={filterOption.love_exist} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">こだわらない</option>
          <option value="いる">恋愛感情あり</option>
          <option value="いる">恋愛感情なし</option>
<option value="いない">その他</option>
        </select>
      </div>
      
          <div className="filtered-members-form-group">
        <label>友情結婚の願望</label>
        <select name="friendship_marriage" value={filterOption.friendship_marriage} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">こだわらない</option>
          <option value="いる">望む</option>
          <option value="いる">望まない</option>
<option value="いない">その他</option>
        </select>
      </div>
      <div className="filtered-members-form-group">
        <label>子供の希望:</label>
        <select name="children_want" value={filterOption.children_want} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">こだわらない</option>
<option value="欲しい">欲しい</option>
<option value="欲しくない">欲しくない</option>
        </select>
      </div>
      <div className="filtered-members-form-group">
        <label>子供の有無</label>
        <select name="children_have" value={filterOption.children_have} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">こだわらない</option>
          <option value="いる">いる</option>
<option value="いない">いない</option>
        </select>
      </div>
      <div className="filtered-members-form-group">
        <label>結婚歴:</label>
        <select name="marital_status" value={filterOption.marital_status} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">こだわらない</option>
<option value="未婚">未婚</option>
<option value="離婚">離婚</option>
        </select>
      </div>
      <div className="filtered-members-form-group">
        <label>同居に関して:</label>
        <select name="cohabiter_aim" value={filterOption.cohabiter_aim} onChange={handleFilterChange} className="filtered-members-select">
          <option value="all">こだわらない</option>
<option value="未婚">一緒に住みたい</option>
<option value="離婚">同居を希望しない</option>
<option value="離婚">場合による</option>
        </select>
      </div>
        </div>
        
      )}
            <button onClick={handleApplyFilter} className="filtered-members-apply-button">条件を保存</button>
    </div>
  );
};

export default FilteredMembers;
